var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as _ from 'lodash';
var VariantsService = /** @class */ (function () {
    function VariantsService(api) {
        this.api = api;
    }
    VariantsService.prototype.setDataToForm = function (updatedFormConfig, variant, productOptionType) {
        _.set(updatedFormConfig, 'price.value', variant.Price);
        _.set(updatedFormConfig, 'old_price.value', variant.OldPrice);
        _.set(updatedFormConfig, 'status.value', variant.Status);
        _.set(updatedFormConfig, 'status.value', variant.Status);
        _.set(updatedFormConfig, 'barcode.value', variant.Barcode);
        _.set(updatedFormConfig, 'barcode.value', variant.Barcode);
        _.set(updatedFormConfig, 'default.value', variant.Default);
        _.set(updatedFormConfig, 'use_as_main_in_list.value', variant.UseAsMainInList);
        _.set(updatedFormConfig, 'packaging.value', variant.Packaging);
        _.set(updatedFormConfig, 'bg_composition.value', variant.BgComposition);
        _.set(updatedFormConfig, 'en_composition.value', variant.EnComposition);
        _.set(updatedFormConfig, 'position.value', variant.Position);
        _.set(updatedFormConfig, 'external_id.value', variant.ExternalId);
        _.set(updatedFormConfig, 'gift.value', variant.GiftsFormatted);
        _.set(updatedFormConfig, 'gift.touched', true);
        _.set(updatedFormConfig, 'gift.valid', true);
        _.set(updatedFormConfig, 'stock_status.value', variant.StockStatus);
        _.set(updatedFormConfig, 'stock_status.value', variant.StockStatus);
        if (productOptionType) {
            _.set(updatedFormConfig, 'option_value.value', {
                label: variant.OptionValueName,
                value: variant.OptionValueId,
            });
        }
        // all fields are touched and valid since they are loaded in the form successfuly
        for (var key in updatedFormConfig) {
            if (Object.prototype.hasOwnProperty.call(updatedFormConfig, key)) {
                var element = updatedFormConfig[key];
                _.set(updatedFormConfig, key + ".touched", true);
                _.set(updatedFormConfig, key + ".valid", true);
            }
        }
    };
    // The method wchich is going to be called in the component to return all the options
    // It will call each private method as a chain and it returns a promise
    VariantsService.prototype.fetchAsyncFieldsOptions = function (productId) {
        return __awaiter(this, void 0, Promise, function () {
            var _a, statuses, product, stock_statuses;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.api.getVariantStatuses(productId),
                            this.api.getProduct(productId),
                            this.api.getVariantQuantity(productId)
                        ])];
                    case 1:
                        _a = _b.sent(), statuses = _a[0], product = _a[1], stock_statuses = _a[2];
                        return [2 /*return*/, {
                                statuses: statuses.data,
                                product: product.data,
                                stock_statuses: stock_statuses.data
                            }
                            /* return new Promise((resolve: any, reject: any) =>
                                this.getVariantsStatuses(productId)
                                    .then(data => {
                                        resolve(data);
                                    })
                                    .catch((error: AxiosError) => {
                                        reject(error);
                                    })
                            ); */
                            /*  const [categories, category, brands, brand, initialProducts, footerLinks] = await Promise.all([
                                 api.getCategories(),
                                 api.getCategory(slug), // getting categories data for the side menu and header menu
                                 api.getBrandsHeader(),
                                 api.getBrand(slug), // getting brand for the rest of the brand info
                                 api.getBrandsInitialProducts(slug), // getting brand initial products
                                 api.getAllFooterLinks(), // getting all footer pages
                             ]); */
                        ];
                }
            });
        });
    };
    // Asynchronous getting of the statuses
    VariantsService.prototype.getVariantsStatuses = function (productId) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return _this.api
                            .getVariantStatuses(productId)
                            .then(function (response) {
                            var resolveData = {
                                statuses: response.data,
                            };
                            resolve(_this.getProduct(resolveData, productId));
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    // Asynchronous getting of the option types
    VariantsService.prototype.getProduct = function (resolveData, productId) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return _this.api
                            .getProduct(productId)
                            .then(function (response) {
                            resolve(Object.assign(resolveData, {
                                product: response.data,
                            }));
                            resolve(_this.getVariantStock(resolveData, productId));
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    VariantsService.prototype.getVariantStock = function (resolveData, productId) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return _this.api
                            .getVariantQuantity(productId)
                            .then(function (response) {
                            resolve(Object.assign(resolveData, {
                                stock_statuses: response.data,
                            }));
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    return VariantsService;
}());
export default VariantsService;



//////////////////
// WEBPACK FOOTER
// ./src/services/variants.service.ts
// module id = 506
// module chunks = 0